$(function () {
    $(".file-uploader").each(function () {
        mountFileUploader(this);
    });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(addedNode => {
                    let parentNode = addedNode.parentNode;
                    while (parentNode) {
                        if (parentNode.id && (parentNode.id.includes('editable-fields') || parentNode.id.includes('order-add-form') || parentNode.id.includes('attendee-add-form'))) {
                            mountFileUploader(mutation.addedNodes[0].parentNode);
                          break;
                        }

                        parentNode = parentNode.parentNode;
                    }
                });
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // For accessibility, "enter" keydown events should trigger the file uploader
    if ($('.fileinput-button') && $('.fileinput-button')[0]) {
        $('.fileinput-button')[0].addEventListener('keydown', function (e) {
            if (e.key.toLowerCase() === "enter") {
                $('.fileinput-button')[0].children[2].click();
            }
        });
    }
});

function mountFileUploader(rootUploaderEl) {
    $(rootUploaderEl).find("input[type=file]").each(initFileUpload);
    $(rootUploaderEl).on("click", ".remove-file", removeFile);
    $(rootUploaderEl).on("click", ".rename-custom-file", renameCustomFile);
    $(rootUploaderEl).on("click", ".remove-custom-file", removeCustomFile);
    $(rootUploaderEl).on("click", ".replace-custom-file", replaceCustomFile);
    $(rootUploaderEl).on("click", ".select-from-files", selectFile);
    $(rootUploaderEl).on("click", ".edit-crop", editCrop);
    $(rootUploaderEl).on("click", ".save-crop", saveCrop);

    handleCensusSubmitBtn(rootUploaderEl);    

    $(rootUploaderEl).find("input[type=file]").each(disableFileInputs);
}

function resetFileUploader(rootUploaderEl, filePath) {
  if (rootUploaderEl.find('.file-uploader-img').attr('src') != baseFileUrl + filePath) {
    FileAdded(filePath, rootUploaderEl, filePath);
    rootUploaderEl.find('[name$="_Original"]').val(filePath)
  }
}

function initFileUpload(index, element) {
    $(this).fileupload({
        url: uploadFileUrl,
        dataType: 'json',
        maxFileSize: 20000000,
        formData: {
            '__RequestVerificationToken': $("[name='__RequestVerificationToken']").val()
        },
        dropZone: $(this).parents(".file-uploader"),
        processalways: function (e, data) {
            var index = data.index,
                file = data.files[index];
            if (file.error) {
                ShowErrorMessage($(this), file.error);
            }
        },
        submit: function (e, data) {
            if (!data.formData)
                data.formData = {};

            data.formData.TargetFolder = $(this).parents(".file-uploader").data("target-folder");
            data.formData.__RequestVerificationToken = $("[name='__RequestVerificationToken']").val();
            data.formData.ReturnBase64 = $(element).data("return-base64");
            data.formData.ContainerType = $(element).data("container-type");
        },
        send: function (e, data) {
            var parentContainer = $(this).parents(".file-uploader");
            parentContainer.find(".progress-bar").css('width', 0);
            parentContainer.find(".progress").show();
            parentContainer.find(".error-message").remove();
            $("[type='submit']").prop("disabled", true);
        },
        done: function (e, data) {
            if (data.result.error) {
                ShowErrorMessage($(this), data.result.error);
                return;
            }
            var file = data.result;
            var parentContainer = $(this).parents(".file-uploader");

            var customFieldID = $(element).data("custom-field-id");
            var isParentCustomer = $(element).data("is-parent-customer") == "True" || $(element).data("is-parent-customer") == true;
            var isCustomerImage = $(element).data("is-customer-image") == "True";
            var fieldPrefix = $(element).data("field-prefix");
            var fileLimit = $(element).data("file-limit");
            FileAdded(file.name, parentContainer, file.fullPath, file.type, file.size, customFieldID, isParentCustomer, isCustomerImage, fileLimit, fieldPrefix);
            $(this).trigger("file-upload-done", [file]);
        },
        progressall: function (e, data) {
            var progress = parseInt(data.loaded / data.total * 100, 10);
            $(this).parents(".file-uploader").find(".progress-bar").css('width', progress + '%');
        },
        always: function (e, data) {
            $("[type='submit']").prop("disabled", false);
        }
    });
}

function removeFile(e) {
    var parentContainer = $(e.target).parents(".file-uploader");
    var hiddenFileNameInput = parentContainer.find("[type=hidden]:first");
    updateFileName(hiddenFileNameInput, "");

    var croppieContainerElement = parentContainer.find(".file-uploader-img-container");
    var imgPreviewElement = parentContainer.find("img");
    var croppieElement = parentContainer.find(".file-uploader-croppie");

    var editCropButton = parentContainer.find(".edit-crop");
    var saveCropButton = parentContainer.find(".save-crop");

    croppieContainerElement.addClass("hidden");
    saveCropButton.addClass("hidden");
    editCropButton.addClass("hidden");
    imgPreviewElement.addClass("hidden");
    croppieElement.croppie('destroy');

    //if (parentContainer.data("crop-type")) {
    //    var imgCroppie = parentContainer.find(".file-uploader-croppie");
    //    var imageContainer = parentContainer.find(".file-uploader-img-container");
    //    //imgCroppie.croppie('bind', {
    //    //    url: ''
    //    //});
    //    imageContainer.addClass("hidden");
    //    parentContainer.find(".save-crop").addClass("hidden");
    //}
    //else {
    parentContainer.find(".file-link").remove();
    //}

    $(e.target).addClass("hidden");

    var fileUploaderButton = $(e.target).parent().find("a.fileinput-button");
    if (fileUploaderButton.length > 0) {
        fileUploaderButton.find("span").html(fileUploaderButton.find("span").html().replace("Replace", "Upload"));
    }

    return false;
}

function deleteFile(target) {
    var parentContainer = $(target).parents(".file-list");
    var customFieldID = parentContainer.parents(".file-uploader").find("input[type='file']").data("custom-field-id");
    var prefix = parentContainer.parents(".file-uploader").find("input[type='file']").data("field-prefix");
    var isParentCustomer = parentContainer.parents(".file-uploader").find("input[type='file']").data("is-parent-customer") == "True";
    $(target).parent().remove();
    var customFieldFiles = parentContainer.find(".custom-field-file");

    var hiddenFileNameInput = parentContainer.parents(".file-uploader").find("[type=hidden]:first");

    var fileNameToRemove = target.getAttribute('data-file-name');
    var fileList = JSON.parse(hiddenFileNameInput.attr('value'));
    fileList = fileList.filter((f) => { return f.FileName != fileNameToRemove });
    updateFileName(hiddenFileNameInput, JSON.stringify(fileList));

    // if no files are left for this custom field file, add the hidden input so the server knows to delete the file
    if (customFieldFiles.length == 0) {

        let inputName = "";
        if (prefix && prefix.includes("Order")) {
            inputName = `${prefix}CustomField_${customFieldID}`;
            customFieldInput = parentContainer.parents(".file-uploader").siblings(`input[name="${inputName}"]`);
            customFieldInput.attr("value", "");
        } else {
            inputName = `${isParentCustomer ? "Parent" : ""}CustomFieldFile_${customFieldID}`;
        }

        parentContainer.append(`<input id="empty-custom-field-file" name="${inputName}" class="hidden" type="text" value=""/>`);

        // update button labels
        var fileUploaderButton = parentContainer.parents(".file-uploader").find("span.file-input-label-single");
        fileUploaderButton.html("Upload File");
        fileUploaderButton = parentContainer.parents(".file-uploader").find("span.file-input-label-multiple");
        fileUploaderButton.html("Upload File(s)");
    }

    var customFieldFiles = parentContainer.find(".custom-field-file");
    var fileCount = customFieldFiles.length;
    var fileLimit = parentContainer.parents(".file-uploader").find("input[type='file']").data("file-limit");

    if (fileCount < fileLimit) {
        parentContainer.parents(".file-uploader").find(".fileinput-button").removeClass("disabled");
        parentContainer.parents(".file-uploader").find(".fileinput-button input[type='file']").prop("disabled", false);
    }
}

function renameCustomFile(e) {
    var fileName = $(e.target).data("file-name");
    var fullPath = $(e.target).data("full-path");
    var fileExtension = fileName.split('.').pop();
    ShowRenameModal(fileName, function (newName) {
        $.ajax({
            url: renameFileUrl,
            type: 'POST',
            data: {
                "fullPath": fullPath,
                "newName": newName
            },
            success: function (data) {
                if (data && data.status == "OK") {
                    newName = `${newName}.${fileExtension}`;
                    ShowSavedPopup(`${fileName} renamed to ${newName}`, '');
                    var newFileLink = `${customFieldFileBaseUrl}/${fullPath.split('/').pop()}?fileName=${newName}`;

                    // e.target is the rename-custom-file icon
                    var renameIcon = $(e.target).first();
                    renameIcon.siblings(".file-name").text(newName);
                    renameIcon.attr("data-file-name", newName);
                    renameIcon.siblings("a").attr("href", newFileLink);
                    renameIcon.siblings(".remove-custom-file").attr("data-file-name", newName);
                    renameIcon.siblings(".replace-custom-file").attr("data-file-name", newName).attr("href", newFileLink);
                    var fileInput = renameIcon.siblings("input");
                    var fileInfo = JSON.parse(decodeURIComponent(fileInput.val()));
                    fileInfo.fileName = newName;
                    fileInput.attr("value", encodeURIComponent(JSON.stringify(fileInfo)));

                    if (filesViewModel) {
                        filesViewModel.TriggerReload(new Date());
                    }
                }
            }
        });
    });
}

function removeCustomFile(e) {
    var fileName = $(e.target).data("file-name");
    ShowConfirmationModal(`Are you sure you want to delete ${fileName}?`, function () {
        deleteFile(e.target);
    });
}

function replaceCustomFile(e) {
    var fileName = $(e.target).data("file-name");
    ShowConfirmationModal(`Are you sure you want to replace ${fileName}?`, function () {
        deleteFile(e.target);
    }, null, null, null, null, null, function () {
        const targetElement = e.target.parentElement.nextElementSibling;
        if (targetElement) {
            const customFile = targetElement.querySelector('.remove-custom-file');
            deleteFile(customFile);
        }
    });
}

function selectFile(e) {
    var uploader = $(e.target).parents(".file-uploader").find("input[type=file]");
    var extensions = $(e.target).data("extensions");
    var browseOptions = {
        title: 'Novi Files',
        multiple: false,
        extensions: extensions,
        oninsert: function (args) {
            var pathToFile = args.focusedFile.url;
            srcToFile(pathToFile, args.focusedFile.name).then(function (file) {
                uploader.fileupload('add', { files: [file] });
            });
        }
    };
    if (typeof (moxman) == "undefined") {
        $('<script>').attr('type', 'text/javascript').attr('src', moxieManagerScriptUrl).appendTo('body');
        var moxieIntervalID = setInterval(function () {
            if (typeof (moxman) != "undefined") {
                moxman.browse(browseOptions);
                clearInterval(moxieIntervalID);
            }
        }, 100);
    } else {
        moxman.browse(browseOptions);
    }
    return false;
}

function editCrop(e) {
    initCroppie($(e.target));
}

function saveCrop(e) {
    var uploaderContainer = $(e.target).parents(".file-uploader");
    var uploader = uploaderContainer.find("input[type=file]");
    var croppieContainerElement = uploaderContainer.find(".file-uploader-img-container");
    var croppieElement = uploaderContainer.find(".file-uploader-croppie");
    var imgPreviewElement = uploaderContainer.find("img");

    uploaderContainer.data("saving-crop", true);

    var fileName = croppieElement.data("file-name");

    //Our only two result formats are JPEG & PNG - If the file name isn't one of those, we have to adjust file name to be PNG
    var resultFormat = fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") ? "jpeg" : "png";
    if (!fileName.endsWith(".png") && resultFormat == "png") {
        fileName = fileName.replace(/\.[^/.]+$/, "") + ".png";
    }

    var resultOptions = {
        type: 'blob',
        circle: false,
        size: 'original',
        format: resultFormat,
    };

    //JPEG has no transparency, so we have to fill the background with something
    if (resultFormat == "jpeg") {
        resultOptions.backgroundColor = '#FFFFFF';
    }

    croppieElement.croppie('result', resultOptions).then(function (blob) {
        uploader.fileupload('add', {
            files: [new File([blob], fileName, {
                type: blob.type,
            })]
        });
    });
}

function initCroppie(element) {
    var uploaderContainer = $(element).parents(".file-uploader");
    var croppieContainerElement = uploaderContainer.find(".file-uploader-img-container");
    var croppieElement = uploaderContainer.find(".file-uploader-croppie");
    var imgPreviewElement = uploaderContainer.find("img");

    var editCropButton = uploaderContainer.find(".edit-crop");
    var saveCropButton = uploaderContainer.find(".save-crop");

    var finalWidth = $(uploaderContainer).data("width");
    var finalHeight = $(uploaderContainer).data("height");
    var finalRatio = finalHeight / finalWidth;

    var width = Math.ceil(Math.min(uploaderContainer.width(), finalWidth));
    var height = Math.ceil(width * finalRatio);

    editCropButton.addClass("hidden");
    imgPreviewElement.addClass("hidden");
    croppieContainerElement.removeClass("hidden");
    saveCropButton.removeClass("hidden");

    
    var cropType = $(uploaderContainer).data("crop-type").toLowerCase();
    

        var croppieInstance = $(croppieElement).croppie({
            viewport: {
                width: width - 2,
                height: height - 2,
                type: cropType
            },
            mouseWheelZoom: false,
            boundary: { width: width, height: height },
            enforceBoundary: false
        });
    $(uploaderContainer).find(".cr-slider").addClass("ignore");

    croppieElement.data("file-name", imgPreviewElement.attr("alt"));
    croppieElement.croppie('bind', { url: imgPreviewElement.attr("src") });
}

function FileAdded(fileName, parentContainer, fullPath, contentType, size, customFieldID = 0, isParentCustomer = false, isCustomerImage = false, fileLimit = 1, prefix = "") {
    $("[type='submit']").prop("disabled", true);
    var lowerFileName = fileName.toLowerCase();
    var isImage = lowerFileName.indexOf(".jpg") > 0 || lowerFileName.indexOf(".jpeg") > 0 || lowerFileName.indexOf(".gif") > 0
        || lowerFileName.indexOf(".png") > 0 || lowerFileName.indexOf(".bmp") > 0 || lowerFileName.indexOf(".ico") > 0 || lowerFileName.indexOf(".svg") > 0;

    let showFileLink = true;

    // This is a override to make sure the link does not show. For example the signature. 
    if (parentContainer.data("hide-link")) {
        showFileLink = false;
    }

    if (isImage) {
        var tempImgUrl = baseFileUrl + fullPath;
        var croppieElement = parentContainer.find(".file-uploader-croppie");
        //If we are using croppie in this file uploader, we need to run bind to correctly attach to the new image

        if (croppieElement.is(":visible") == true && parentContainer.data("saving-crop") != true) {
            croppieElement.data("file-name", fileName);

            croppieElement.croppie('bind', {
                url: tempImgUrl
            });
        }
        else {
            var croppieContainerElement = parentContainer.find(".file-uploader-img-container");
            var imgPreviewElement = parentContainer.find("img");

            var editCropButton = parentContainer.find(".edit-crop");
            var saveCropButton = parentContainer.find(".save-crop");
            
            var imgPreview = parentContainer.find("img");
            var imgWidth = parentContainer.data("width");
            var imgHeight = parentContainer.data("height");
            
            imgPreviewElement.attr("alt", fileName).attr("src", tempImgUrl + "?" + "t=" + Math.floor(new Date() / 1000));

            if (parentContainer.data("saving-crop") == true) {

                croppieContainerElement.addClass("hidden");
                saveCropButton.addClass("hidden");
                editCropButton.removeClass("hidden");
                imgPreviewElement.removeClass("hidden");
                parentContainer.data("saving-crop", false);
                croppieElement.croppie('destroy');
            }
            else if (parentContainer.data("crop-type")) {
                initCroppie(editCropButton);
            }
            else {
                imgPreviewElement.removeClass("hidden");
            }

            // We need to check to make sure that the Croppie-Container and Preview-element are present.  If not, then we will show the file link.
            if (croppieContainerElement.length > 0 || imgPreviewElement.length > 0) {
                showFileLink = false;
            }
        }
    }

    if (showFileLink) {
        if (customFieldID > 0) {
            $("#empty-custom-field-file").remove();

            var customFieldFiles = parentContainer.find(".custom-field-file");
            var fileList = parentContainer.find(".file-list");
            var fileCount = customFieldFiles.length + 1;

            // if file upload input does not have multiple attribute, we need to delete the existing custom field file input
            if (!parentContainer.find("input[type=file]").attr("multiple")) {
                parentContainer.find(".replace-custom-file").click();
            }

            var multiFileUploaderButton = parentContainer.find("span.file-input-label-multiple");

            if (fileLimit > 1 && fileCount > fileLimit) {
                parentContainer.find(".fileinput-button").addClass("disabled");
                parentContainer.find(".fileinput-button input[type='file']").prop("disabled", true);
            } else {
                multiFileUploaderButton.html("Upload Additional File(s)");

                fileList.append(`<span class='custom-field-file' id='${fileCount}'><span class='file-name'>${fileName}</span> <a href='' target='_blank'><i class='fa-solid fa-cloud-arrow-down'></i></a> <i class="fa-solid fa-trash-can remove-custom-file" data-file-name='${fileName}'></i><a class="replace-custom-file" data-file-name='${fileName}' data-custom-field-id='${customFieldID}'></a></span>`);

                var newFileLink = parentContainer.find(`#${fileCount} a`);
                newFileLink.attr("href", customFieldFileBaseUrl + "/temp?fileName=" + fullPath.substring(fullPath.indexOf("/temp") + 6));

                var fileInfo = {
                    fileName: fileName,
                    contentType: contentType,
                    fullPath: fullPath,
                    size: size
                };

                var jsonString = JSON.stringify(fileInfo);

                let inputName = "";
                if (prefix.includes("Order") || prefix.includes("Cart")) { // ecommerce
                    inputName = `${prefix}CustomField_${customFieldID}`;
                } else {
                    inputName = `${isParentCustomer ? "Parent" : ""}CustomFieldFile_${customFieldID}`;
                }

                var customFieldInput = parentContainer.find(`input[name="${inputName}"]`);

                if (customFieldInput.length <= fileCount) {
                    newFileLink.parent().append(`<input name="${inputName}" value="${encodeURIComponent(jsonString)}" class="hidden"/>`);
                } else {
                    customFieldInput.attr("value", `${encodeURIComponent(jsonString)}`);
                }

                var fileUploaderButton = parentContainer.find("span.file-input-label-single");
                fileUploaderButton.html("Replace File");
            }
        } else {
            var fileLink = parentContainer.find(".file-link");
            if (fileLink.length == 0) {
                parentContainer.prepend('<a class="file-link" target="_blank" />');
                fileLink = parentContainer.find(".file-link");
            }

            fileLink.attr("href", baseFileUrl + fullPath).html(fileName);
        }
    }

    parentContainer.find(".remove-file").removeClass("hidden");

    var hiddenFileNameInput = parentContainer.find("[type=hidden]:first");
    updateFileName(hiddenFileNameInput, fullPath);
    parentContainer.find(".progress").fadeOut(5000);

    const fileAddedEvent = new CustomEvent('fileAdded', { detail: { fileName: fileName } });
    parentContainer[0].dispatchEvent(fileAddedEvent);

    if (isCustomerImage) {
        var fileInfo = {
            fileName: fileName,
            contentType: contentType,
            fullPath: fullPath,
            size: size
        };

        var jsonString = JSON.stringify(fileInfo);
        var imageInput = parentContainer.find("[type=hidden]:first");
        var encodedString = encodeURIComponent(jsonString);
        imageInput.attr("value", encodedString);
    }

    $("[type='submit']").prop("disabled", false);
}

function updateFileName(hiddenInput, newFileName) {
    hiddenInput.val(newFileName);
    if (hiddenInput[0]) {
        hiddenInput[0].dispatchEvent(new CustomEvent('updateFileName', { detail: newFileName }));
    }
}

function srcToFile(src, fileName) {
    return (fetch(src)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new File([buf], fileName); })
    );
}

function ShowErrorMessage(fileUploader, error) {
    var parentContainer = fileUploader.parents(".file-uploader");
    var errorMessage = parentContainer.find(".error-message");

    if (errorMessage.length == 0) {
        parentContainer.append('<div class="alert alert-danger text-danger error-message" style="margin-top:5px;">  </div>');
        errorMessage = parentContainer.find(".error-message");
    }

    errorMessage.html("<span class='novicon novicon-warning' style='margin-right:5px;'></span> " + error);
}

function disableFileInputs(index, element) {
    if ($(element).data("file-limit")) {
        var parentContainer = $(element).parents(".file-uploader").find(".file-list");
        var customFieldFiles = parentContainer.find(".custom-field-file");
        var fileCount = customFieldFiles.length;
        var fileLimit = parentContainer.parents(".file-uploader").find("input[type='file']").data("file-limit");
        if (fileCount >= fileLimit) {
            $(element).parents(".file-uploader").find(".fileinput-button").addClass("disabled");
            $(element).prop("disabled", true);
        }
    }
}

function handleCensusSubmitBtn(rootUploaderEl) {
    // If on the census form, we need to identify changes to the file upload element
    // so that we can change the value of the submit button
    if ($('#censusForm #census-form-submit-btn').length) {
        rootUploaderEl.addEventListener('fileAdded', function () {
            $('#censusForm #census-form-submit-btn').val('Save');
        });

        $(rootUploaderEl).on('click', '.fileinput-button, .remove-file, .save-crop', function () {
            $('#censusForm #census-form-submit-btn').val('Save');
        });
    }
}